import AppContext from "../utils/app-context.js";
import { v4 as uuidv4 } from 'uuid';
import {
  Button,
  Link
} from "@mui/material";
import assets from "../utils/assets";
import Messages from "../constants/app";
import toast from "react-hot-toast";
import { doc, setDoc, getDoc, serverTimestamp } from "@firebase/firestore";
import { ref, uploadBytesResumable, getDownloadURL } from "@firebase/storage"
import { emptyStory, sortTakes, getMediaUrl } from "../utils/utility.js";
import { db, storage } from "../utils/firebase"
import { nanoid } from "nanoid";
import hostConfig from "../utils/config";
import { methods, baseVideos } from "../constants/index.js"

export const uploadBlob = (props) => {
  const { blob, dispatch, path, firebase } = props;
  const storageRef = ref(storage, path);

  dispatch({ type: "START_UPLOAD", payload: { totalBytes: blob.size, totalFiles: 1 } });

  let uploadResolve, uploadReject;
  const uploadPromise = new Promise((resolve, reject) => {
    uploadResolve = resolve;
    uploadReject = reject;
  });

  //const blobRef = storageRef.child(path)

  const uploadNext = (snapshot) => {
    // const percent = snapshot.bytesTransferred / snapshot.totalBytes * 100;
    const bytes = snapshot.bytesTransferred;
    dispatch({ type: "FILE_UPLOAD_UPDATE", payload: { path, bytes } });
  }

  const uploadError = (error) => {
    console.log(`Error uploading blob`, error)
    uploadReject(error)
  }

  const uploadComplete = () => {
    dispatch({ type: "FILE_UPLOAD_SUCCESS", payload: {} });
    uploadResolve('upload completed');
  }

  const blobUploadTask = uploadBytesResumable(storageRef, blob);

  blobUploadTask.on('state_changed', snapshot => {
    switch (snapshot.state) {
      case 'running':
        uploadNext(snapshot)
        break;
    }
  }, (error) => {
    uploadError()
  }, () => {
    uploadComplete()
  });

  return uploadPromise;
}

export const videoUpload = async (props) => {
  const { file, shot_id, state, dispatch, storyImport, currentUser, firebase, is_ref, callback, source = "upload", addUserRef = false } = props;
  const file_MB = file.size / 1000000
  const alert_thresh_MB = 25
  const is_vertical = state.stories.activeStory.is_vertical || false;
  let success = false;
  let portalId = props.portalId;

  const max_MB = (state.app.userIsStoryOwner && state.app.settings.userCanUploadLargeFiles) ? 250 : 50
  if (!storyImport && file_MB > max_MB) {
    alert(`Please choose a shorter video. ${file_MB.toPrecision(3)}MB is over the ${max_MB}MB limit for this project's settings.`)
  } else if (storyImport && file_MB > max_MB) {
    alert(`Please choose a shorter video. ${file_MB.toPrecision(3)}MB is over the ${max_MB}MB limit for import.`)
  } else {
    if (!storyImport && file_MB > alert_thresh_MB) {
      alert(`This file is larger than expected for the recommended 1-6 second video. Upload will resume.`)
    } else if (storyImport && file_MB > alert_thresh_MB) {
      alert(`This file is larger than expected. Upload will resume, but processing may take longer than usual.`)
    }
    if (storyImport) console.log("onFileUploadChange ... " + "insert story" + " " + file_MB.toPrecision(3) + "MB")
    else console.log("onFileUploadChange ... " + shot_id + " " + file_MB.toPrecision(3) + "MB")

    const id = uuidv4();
    const storageDir = "media"
    let oid = "unknown"
    let sid = "unknown"
    let uploader_id = currentUser ? currentUser.uid : "unknown";
    //const path = `${storageDir}/${filename}.mp4`

    if (storyImport) {
      //handleContinueEmpty({dispatch:dispatch, portalId:portalId});
      // story_path_array[story_path_array.length - 1] = portalId;
      oid = currentUser.uid;
      if (state.stories.activeStory?.portal_id !== portalId) {
        handleContinueEmpty({ dispatch: dispatch, portalId: portalId });
      }
      // path = `${storageDir}/us/${oid}/st/${sid}/up/${uploader_id}/imports/${id}.mp4`
    } else if (state.stories.activeStory && state.stories.activeStory.ref) {
      // const story_path = state.stories.activeStory.ref.u_.path 
      // const OID_ind = story_path.segments.findIndex((item) => item == "users") + 1 
      const story_path_array = state.stories.activeStory.ref.path.split("/");
      const OID_ind = story_path_array.findIndex((item) => item == "users") + 1
      oid = story_path_array[OID_ind]

      const SID_ind = story_path_array.findIndex((item) => item == "stories") + 1
      sid = story_path_array[SID_ind]
    }
    const path = (storyImport) ? `${storageDir}/us/${oid}/st/${portalId || sid}/up/${uploader_id}/imports/${id}.mp4` : `${storageDir}/us/${oid}/st/${sid}/up/${uploader_id}/ta/${id}.mp4`

    const uploadPromise = uploadBlob({ blob: file, dispatch: dispatch, path: path, firebase: firebase })
    const result = await uploadPromise;

    if (result === 'upload completed') {
      success = true;
      //event.target.value = null
      if (storyImport) {
        if (callback) {
          callback();
        }
        const payload = {
          video_path: path,
          thumbnail: state.stories.activeStory?.is_vertical ? assets['processing_thumb_vert'] : assets['processing_thumb'],
          id: id,
          type: "storyboard",
          scene_thresh: 0.3, // sensitive:0.2  normal:0.3   strict: 0.4 
          max_shot_dur_ms: 4000,
          include_audio: state.app.settings.videoImportIncludesAudio,
          is_vertical: is_vertical,
          //storyId: state.stories.activeStory.ref.id || null, 
          portalId: portalId || null,
          currentUser: currentUser,
          source: source
        }
        dispatch({ type: "STORY_IMPORT", payload: payload })
        toast.success(Messages.info.autoStoryBoardStarted);
      } else {
        if (shot_id) {
          const payload = {
            video_path: path,
            thumbnail: state.stories.activeStory?.is_vertical ? assets['processing_thumb_vert'] : assets['processing_thumb'],
            shot_id: shot_id,
            is_vertical: is_vertical,
            take_id: id,
            source: source
          }
          dispatch({ type: "ADD_TAKE_TO_SHOT", payload: payload })
          if (!is_ref && callback) {
            callback();
          }
          //setSelected();
          //setTakesCount(takesCount + 1)
          const lastPayload = {
            take_id: id,
            image: state.stories.activeStory?.is_vertical ? assets['processing_thumb_vert'] : assets['processing_thumb'],
            stream_path: path,
            shot_id: shot_id
          };
          dispatch({ type: "UPDATE_SHOT_LAST_TAKE", payload: lastPayload })
        }
        if (is_ref) {
          const take_payload = {
            video_path: path,
            thumbnail: state.stories.activeStory?.is_vertical ? assets['processing_thumb_vert'] : assets['processing_thumb'],
            shot_id: "reference",
            id: id,
            is_ref: true,
            is_vertical: is_vertical
          }
          if (callback) {
            if (callback) callback({ take: take_payload, file: file });
          }
          dispatch({ type: "ADD_TAKE_REF", payload: { take: take_payload, addUserRef: addUserRef } });
        }
        toast.success(Messages.info.mediaUploadCompleted);
      }
    }
  }
  return success;
}

export const imageUpload = async (props) => {
  const { file, state, dispatch, shot_id, is_ref, currentUser, callback, firebase, path, source = "upload", addUserRef = false } = props
  const file_MB = file.size / 1000000
  const max_MB = 15
  const storyRef = state.stories.activeStoryRef;
  const is_vertical = state.stories.activeStory.is_vertical || false;
  if (file_MB > max_MB) {
    alert(`Please use a smaller file size.  Check resolution or compression type (JPG, PNG, WEBP). ${file_MB.toPrecision(3)}MB is over the ${max_MB}MB limit for this project's settings.`)
  } else {
    const take_id = uuidv4();
    const storageDir = "media"
    let oid = currentUser ? currentUser.uid : "unknown";
    let sid = is_ref ? "reference" : "unknown";
    if (state?.stories?.activeStory && state?.stories?.activeStory?.ref) {
      const story_path_array = state.stories.activeStory.ref.path.split("/");
      const OID_ind = story_path_array.findIndex((item) => item == "users") + 1
      oid = story_path_array[OID_ind]

      const SID_ind = story_path_array.findIndex((item) => item == "stories") + 1
      sid = story_path_array[SID_ind]
    }

    if (['image/jpeg', 'image/webp', 'image/png'].includes(file.type)) {
      var ext = file.type.substr(file.type.lastIndexOf('/') + 1)
    }
    else {
      alert("Unsupported file type.  Images should be jpeg, webp or png, not '" + file.type + "' -- " + file.name)
      // var re = /(?:\.([^.]+))?$/;
      // var ext = re.exec(file.name)[1]
    }

    const uploader_id = currentUser ? currentUser.uid : "unknown"
    const image_path = (path) ? `${storageDir}/us/${oid}/st/${sid}/up/${uploader_id}/ta/${take_id}.${ext}` : `${storageDir}/us/${uploader_id}/tmp/${take_id}.${ext}`;
    if (image_path) {
      const uploadPromise = uploadBlob({ blob: file, dispatch: dispatch, path: image_path, firebase: firebase })
      let result = await uploadPromise;
      if (result === 'upload completed' && shot_id && shot_id != "reference") {
        toast.success(Messages.info.imageUploadCompleted);
        if (callback) {
          callback({ take_id: take_id, image_path: image_path, file: file });
        }
        const im_payload = {
          image_path: image_path,
          thumbnail: state.stories.activeStory?.is_vertical ? assets['processing_thumb_vert'] : assets['processing_thumb'],
          shot_id: shot_id,
          take_id: take_id,
          is_ref: is_ref,
          is_vertical: is_vertical
        }
        event.target.value = null
        dispatch({ type: "ADD_IMAGE_TO_SHOT", payload: im_payload });
        //setSelected();
        //setTakesCount(takesCount + 1)
        const lastPayload = {
          take_id: take_id,
          image: state.stories.activeStory?.is_vertical ? assets['processing_thumb_vert'] : assets['processing_thumb'],
          stream_path: image_path, //path, 
          shot_id: shot_id
        };
        dispatch({ type: "UPDATE_SHOT_LAST_TAKE", payload: lastPayload })
      } else if (result === 'upload completed') {
        if (is_ref) {
          if (storyRef) {
            const take_payload = {
              image_path: image_path,
              thumbnail: state.stories.activeStory?.is_vertical ? assets['processing_thumb_vert'] : assets['processing_thumb'],
              shot_id: "reference",
              id: take_id,
              is_ref: true,
              is_vertical: is_vertical
            }
            event.target.value = null
            if (callback) callback({ take: take_payload, image_path: image_path, file: file });
            dispatch({ type: "ADD_TAKE_REF", payload: { take: take_payload, addUserRef: addUserRef } });
          } else {
            if (callback) callback({ image_path: image_path, file: file });
            dispatch({ type: "ADD_TMP_REF", payload: { take_id: take_id, path: image_path, file: file } })
          }
        }
      } else if (callback) {
        callback({ image_path: image_path, file: file });
      }
    }
  }
}

export const debounce = (func, wait = 300) => {
  let timeout;
  return function (...args) {
    const context = this;
    clearTimeout(timeout);
    timeout = setTimeout(() => {
      func.apply(context, args);
    }, wait);
  };
}

export const audioUpload = async (props) => {
  const { file, state } = props;
  if (!file) throw Error("No file provided for upload.");
  const currentUserId = state.userData.ref.id
  const file_MB = file.size / 1000000;
  const max_MB = 10; // Set a reasonable limit for audio files

  if (file_MB > max_MB) {
    alert(`Please use a smaller file size. ${file_MB.toPrecision(3)}MB is over the ${max_MB}MB limit.`);
    // throw new Error('File size exceeds limit.');
    throw Error("File size exceeds limit.");
  } else {
    const audio_id = uuidv4();
    const storageDir = "media";
    let oid = "unknown";
    let sid = "unknown";

    if (state?.stories?.activeStory && state?.stories?.activeStory?.ref) {
      const story_path_array = state.stories.activeStory.ref.path.split("/");
      const OID_ind = story_path_array.findIndex((item) => item === "users") + 1;
      oid = story_path_array[OID_ind];

      const SID_ind = story_path_array.findIndex((item) => item === "stories") + 1;
      sid = story_path_array[SID_ind];
    }

    const uploader_id = currentUserId ? currentUserId : "unknown";
    const audio_path = `${storageDir}/us/${oid}/st/${sid}/up/${uploader_id}/audio/${audio_id}.mp3`;

    const storageRef = ref(storage, audio_path);
    const uploadTask = uploadBytesResumable(storageRef, file);

    return new Promise((resolve, reject) => {
      uploadTask.on('state_changed',
        (snapshot) => {
          // Handle progress updates if needed
        },
        (error) => {
          console.error('Error uploading audio:', error);
          // toast.error('Audio upload failed.');
          reject(error);
        },
        async () => {
          try {
            const downloadURL = await getDownloadURL(storageRef);
            // toast.success('Audio upload completed.');
            resolve({ audio_path, downloadURL });
          } catch (error) {
            console.error('Error getting download URL:', error);
            reject(error);
          }
        }
      );
    });
  }
};

export const createVeneer = async (props) => {
  const { prompt, strength, state, dispatch, method_name, is_vertical, method, engine, video_path, shot_id, take_id, ancestor_take_id, cost, composition, style, ref_images } = props;
  const storyRef = state.stories.activeStoryRef;
  const story = state.stories.activeStory;
  const seed = -1;
  const random_seed = seed == -1 ? Math.floor(Math.random() * 100000) + 101000000 : 10;
  const veneer_id = nanoid();  // the new take_id is matched for the veneer and the corresponding take
  const ancestor_id = take_id; // this is a hack, not the true anscestor.  Its jusyt the parent for debug. ToDo: Need to pass this in.
  const creator_id = state.userData.ref.id || "unknown";
  const creator_email = state.userData.email || "unknown";
  const veneer = {
    video_path: video_path,
    audio: "none",
    prompt: prompt,
    strength: strength,
    method_name: method_name,
    method: method,
    engine: engine,
    seed: random_seed,
    shot_id: shot_id,
    take_id: veneer_id,                                      // this is the ID that matches the take that holds veneer, and its used by the backend align to update the take below
    parent_take_id: take_id || null,                                 // for records, we keep a copy of the source take id
    ancestor_take_id: (ancestor_take_id) ? ancestor_take_id : take_id || null,  // oldest known ancestral take_id - the root of a tree
    created_at: serverTimestamp(),
    creator_id: creator_id,
    creator_email: creator_email,
    completed_at: null,
    ref_images: ref_images || [],
    composition: composition,
    style: style,
    cost: cost,
    is_vertical: is_vertical,
  };
  await setDoc(doc(storyRef, "veneer", veneer_id), veneer).then(() => {
    dispatch({ type: "UPDATE_USER_CREDITS", payload: { credits: -cost } });
    if (story.isCompetition && (story.timerStart == undefined || story.activeStory.timerStart == null)) {
      const timerStart = Date.now();
      const payload = { timerStart: timerStart };
      dispatch({ type: "START_STORY_TIMER", payload: payload });
    }
    const takePayload = {
      video_path: assets['processing_veneer_thumb_path'],
      thumbnail: state.stories.activeStory?.is_vertical ? assets['processing_veneer_vert_gif'] : assets['processing_veneer_thumb_gif'], // assets['processing_veneer_thumb'],
      shot_id: shot_id,
      take_id: veneer_id,
      source: "generation",
      generate: true
    }
    dispatch({ type: "ADD_TAKE_TO_SHOT", payload: takePayload })
    const shotPayload = {
      take_id: veneer_id,
      // uploader_id: "veneer", // msg.input.user_id,   // we did this when it was in the cloud  ... now its a name, so autoveneer [disabled] might apply to veneer as well?
      // media_source: "veneer", // ToDo:  this for upload & capture too, also yt
      image: state.stories.activeStory?.is_vertical ? assets['processing_veneer_vert_gif'] : assets['processing_veneer_thumb_gif'],
      stream_path: state.stories.activeStory?.is_vertical ? assets['processing_veneer_vert_streampath'] : assets['processing_veneer_streampath'],
      shot_id: shot_id,
    };

    dispatch({ type: "UPDATE_SHOT_LAST_TAKE", payload: shotPayload })
  })
    .catch((error) => {
      console.log("Error creating veneer request:", veneer);
    });
  console.log("tried VENEER:", veneer);
}

export const createVeneerNewTake = debounce((props) => {
  const { prompt, reimagine, reimagineVeneer, state, dispatch, is_vertical, chosenMethod, chosenModel, shotId, strength, selectedComp, selectedStyle, customStyle, customComp, cost, imageRefs } = props;
  const modelsToExclude = ['vid2vid', 'comfy-FFAutoCine-v0', 'haiper-image'];
  const selectedReimagineItem = reimagine;
  const pathSegments = location.pathname.split('/');
  let lastSeg = pathSegments[pathSegments.length - 1];
  if (lastSeg === 'hunt') lastSeg = pathSegments[pathSegments.length - 2];
  const shot_id = shotId || lastSeg;
  const takesList = sortTakes(state.stories.activeTakeList.filter(take => take.shot_id === shot_id))
  const models = hostConfig.aiModels;
  const cost_per_veneer = cost || hostConfig.veneerCost;
  const ref_images = imageRefs ? imageRefs : [];
  if (prompt === '' && !modelsToExclude.some(model => chosenModel.includes(model))) {
    alert("Please add prompt to create");
    return
  }
  let method_name = "im2im-v4";
  let method = "im2im";
  let engine = "stabilityai/stable-diffusion-2-depth";
  let video_path = null;
  let video_id = null;
  if (selectedReimagineItem) {
    video_path = selectedReimagineItem?.video_path; // the full path w/o the storage bucket
    video_id = selectedReimagineItem?.id;         // for records, we keep a copy of the source video_id as the parent_take_id
  }
  const take_id = (selectedReimagineItem) ? selectedReimagineItem?.id : (ref_images.length > 0) ? state.stories.activeTakeList.find(ref => ref.image_path === ref_images[0])?.id : null;
  const ancestor_take_id = (reimagineVeneer?.ancestor_take_id) ? reimagineVeneer.ancestor_take_id : null

  /*if (chosenModel !== null) {
    method_name = chosenModel.split(',')[0];
    method = chosenModel.split(',')[1];
    engine = chosenModel.split(',')[2];
  }*/
  models.forEach((value, key) => {
    if (key == chosenModel) {
      method_name = key;
      method = value.method;
      engine = value.engine;
      return;
    }
  });
  if (method == "text2vid") {
    // anything that starts w text2video has an API shortcut, where is needs to pass upa video, but does not use it
    // TO DO: Remove defaultPath and replace with null ... which should work if we depricate zeroscope
    video_path = hostConfig.env == "prod" ? "https://storage.googleapis.com/v0zebra.appspot.com/" + baseVideos[hostConfig.env] : "https://storage.googleapis.com/v0zebra-dev.appspot.com/" + baseVideos[hostConfig.env];
    video_id = "";
  }
  createVeneer({ state: state, dispatch: dispatch, is_vertical: is_vertical, prompt: prompt, strength: strength, method_name: method_name, method: method, engine: engine, video_path: video_path, shot_id: shot_id, video_id: video_id, take_id: take_id, ancestor_take_id: ancestor_take_id, cost: cost_per_veneer, composition: { selected: selectedComp, custom: customComp }, style: { selected: selectedStyle, custom: customStyle }, ref_images: ref_images }); // cost is fixed at 10.  fps not under control. selectedItem.dur * fps * lookup
  dispatch({ type: "UPDATE_STORY_SHOT_PROMPT", payload: { prompt: prompt, /*strength: strength, */shot_id: shot_id, /*model: method_name, */composition: { selected: selectedComp, custom: customComp }, style: { selected: selectedStyle, custom: customStyle } } });

  toast.success(Messages.info.videoGenerationStarted);
}, 300)
/* Added by Philip 
const createVeneerForTake = () => {
    const modelsToExclude = ['vid2vid', 'comfy-FFAutoCine-v0', 'haiper-image'];
    if (prompt === '' && !modelsToExclude.some(model => chosenModel.includes(model))) {
      alert("Please add prompt to create");
      return
    }
    console.log("Creating veneer for take", selectedItem);

    if(story.isCompetition && story.timerStart != null && (Date.now() - story.timerStart)/1000 > 1800) {
      setShowReimagine(null)
      setCompAlertOpen(true)
      return
    }
    let method_name = "im2im-v4";
    let method = "im2im";
    let engine = "stabilityai/stable-diffusion-2-depth";
    let video_path = null;
    let video_id = null;
    if(selectedReimagineItem) {
      video_path = selectedReimagineItem?.video_path; // the full path w/o the storage bucket
      video_id = selectedReimagineItem?.id;         // for records, we keep a copy of the source video_id as the parent_take_id
    } 
    // compute ancestor_take_id - oldest known ancestral take_id - the root of a tree to the first video
    const this_take =  takesList.filter((take) => take.id == video_id)[0]  
    let ancestor_take_id = ((this_take) && 'ancestor_take_id' in this_take  && (this_take.ancestor_take_id)) ? this_take.ancestor_take_id : video_id 

    models.forEach((value, key) => {
      if (key == chosenModel) {
        method_name = key;
        method = value.method;
        engine = value.engine;
        return;
      }
    });
    if (method == "text2vid") {
      // anything that starts w text2video has an API shortcut, where is needs to pass upa video, but does not use it
      // TO DO: Remove defaultPath and replace with null ... which should work if we depricate zeroscope
      let defaultPath =
        hostConfig.env == "prod"
          ? "https://storage.googleapis.com/v0zebra.appspot.com/p/st/PsTKsKgJLNGsMiSDiAao/sh/qTF8fXtuzjPuQjj4hJ0aO/ta/cfc95bce-c1a4-43ec-9362-96944a9ebab8/q/2023-07-19T18_27_15_467Z-1.mp4"
          : "https://storage.googleapis.com/v0zebra-dev.appspot.com/p/st/kJW-WfbW-yS9pTY0sxJd/sh/94a49eff-460a-4ebf-af29-9aa7ffd04086/ta/7ab97cde-0230-4730-b5e6-17e0436cf4e7/q/2023-09-28T06-55-41-041Z-1.mp4";
      video_path = defaultPath;
      video_id = "";
    }
    console.log("Creating veneer for take - text2vid", selectedItem);
    createVeneer(prompt, strength, method_name, method, engine, video_path, shot_id, video_id, ancestor_take_id, costPerVeneer); // cost is fixed at 10.  fps not under control. selectedItem.dur * fps * lookup
    dispatch({ type: "UPDATE_STORY_SHOT_PROMPT", payload: { prompt: prompt, strength: strength, shot_id: shot_id, model: chosenModel } });

    toast.success(Messages.info.videoGenerationStarted);

    setSelectedReimagineItem(null);
    setShowReimagine(null);
  }
  */







/*export const createVeneerNewShot = (props) => {
  const {state, dispatch, currentUser, prompt, reimagine, chosenMethod, chosenModel, strength, selectedComp, selectedStyle, customStyle, customComp} = props;
  const shotId = nanoid();
  const models = hostConfig.aiModels;
  const cost_per_veneer = hostConfig.veneerCost;
  //const modelsToExclude = ['vid2vid', 'comfy-FFAutoCine-v0', 'haiper-image'];
  if (prompt === ''/* && !modelsToExclude.some(model => chosenModel.includes(model))*) {
    alert("Please add prompt to create");
    return
  }
  //if(props.textPrompt) setChosenModel("haiper-text");
  console.log("prompt", prompt) //, selectedShot, selectedItem))
  console.log("strength", strength) //, selectedShot, selectedItem))
  console.log("model", chosenModel) //, selectedShot, selectedItem))
  let method = chosenMethod;
  let method_name = chosenModel;
  //console.log("ShotId", shot_id) //, selectedShot, selectedItem))
  //console.log("selectedItem", selectedReimagineItem) //, selectedShot, selectedItem))
  /*let method_name = "im2im-v4";
  let method = "im2im";
  let engine = "stabilityai/stable-diffusion-2-depth";
  let video_path = selectedReimagineItem?.video_path; // the full path w/o the storage bucket
  let video_id = selectedReimagineItem?.id;         // for records, we keep a copy of the source video_id as the parent_take_id
*
  // compute ancestor_take_id - oldest known ancestral take_id - the root of a tree to the first video
  //const this_take =  takesList.filter((take) => take.id == video_id)[0]  
  //let ancestor_take_id = ((this_take) && 'ancestor_take_id' in this_take  && (this_take.ancestor_take_id)) ? this_take.ancestor_take_id : video_id 

  /*if (chosenModel !== null) {
    method_name = chosenModel.split(',')[0];
    method = chosenModel.split(',')[1];
    engine = chosenModel.split(',')[2];
  }*

  addEmptyShot(shotId)

  models.forEach((value, key) => {
    if (key == chosenModel) {
      method_name = value.method_name;
      method = value.method;
      engine = value.engine;
    }
  });

  if (models.has(chosenModel) && models.get(chosenModel).method == "text2vid") {
    // anything that starts w text2video has an API shortcut, where is needs to pass upa video, but does not use it
    // TO DO: Remove defaultPath and replace with null ... which should work if we depricate zeroscope
    let defaultPath =
      hostConfig.env == "prod"
        ? "https://storage.googleapis.com/v0zebra.appspot.com/p/st/PsTKsKgJLNGsMiSDiAao/sh/qTF8fXtuzjPuQjj4hJ0aO/ta/cfc95bce-c1a4-43ec-9362-96944a9ebab8/q/2023-07-19T18_27_15_467Z-1.mp4"
        : "https://storage.googleapis.com/v0zebra-dev.appspot.com/p/st/kJW-WfbW-yS9pTY0sxJd/sh/94a49eff-460a-4ebf-af29-9aa7ffd04086/ta/7ab97cde-0230-4730-b5e6-17e0436cf4e7/q/2023-09-28T06-55-41-041Z-1.mp4";
    video_path = defaultPath;
    video_id = "";
  }
  createVeneer({ state:state, dispatch:dispatch, prompt: prompt, strength: strength, method_name: method_name, method: method, engine: engine, video_path: video_path, /*shot_id: shot_id, video_id: video_id, ancestor_take_id: ancestor_take_id, *cost_per_veneer: cost_per_veneer, composition: { selected: selectedComp, custom: customComp }, style: { selected: selectedStyle, custom: customStyle } }); // cost is fixed at 10.  fps not under control. selectedItem.dur * fps * lookup
  //dispatch({ type: "UPDATE_STORY_SHOT_PROMPT", payload: { prompt: prompt, strength: strength, shot_id: shot_id, model: chosenModel } });

  if (method == "im2im") {
    alert("Creation started. Your new video will be added in 15-30 mins.");
  } else {
    toast.success(Messages.info.videoCreationStarted);
  }
*/

export const addEmptyShot = async (props) => {
  const { dispatch, state, uploading, shotId, partId } = props
  //let description = props.next_shot_index ? props.next_shot_index + ":" : null;
  let newShotId = shotId ? shotId : nanoid()
  let part_id = partId || state.stories.activeStory.parts[0].id;
  const random_int = Math.floor((Math.random() * 18))
  const biased_int = [0, 0, 1, 1, 1, 1, 2, 2, 3, 3, 5, 5, 6, 6, 7, 7, 8, 8, 0][random_int]
  const shot_type_filenames = ["wide.png", "mid.png", "action.png", "close.png", "empty.png", "xcu.png", "two_shot.png", "ots.png", "full.png", "action_close.png",]
  const shot_type = shot_type_filenames[biased_int]
  const random_image = assets["empty_thumbnail"];
  // const random_image = `https://storage.googleapis.com/v0zebra.appspot.com/resource/shot_type/${shot_type}`
  const new_panel_desc = ['Wide shot', 'Mid shot', 'Action shot', 'Close up of face', '', 'Extreme close up', 'Two-Shot', 'Over the shoulder', 'Full shot', 'Action Close up'][biased_int]
  //if(!description) description = new_panel_desc
  //const one_word_title = description.substring(description.lastIndexOf(" ") + 1)
  //const punctuation_free_title = one_word_title.replace(/[".,\/#!$%\^&\*;:{}=\-_`~()]/g, "")
  //const capitalized_title = punctuation_free_title[0].toUpperCase() + punctuation_free_title.substring(1);
  const title = "Shot " + (state.stories.activeShotList.length + 1);
  const newShot = {
    id: newShotId,
    header: title,
    image: random_image,
    meta: "",
    prompt: "",
    description: "",
    last_take_id: null,
    selected_take_id: null,
    last_take_im: (uploading) ? state.stories.activeStory?.is_vertical ? assets["processing_thumb_vert"] : assets["processing_thumb"] : null,
    last_take_stream_url: null,
    deleted_at: null
  };
  const payload = {
    part_id: part_id,
    shot: newShot,
    shot_id: newShot.id,
    auto_title: true
  }
  dispatch({ type: "ADD_STORY_SHOT", payload: payload });
}

export const btnObj2Arr = (props) => {
  const buttons = props.buttons;
  let btnArr = [];
  if (buttons && buttons.length) {
    buttons.map((button, key) => {
      if (button != null && !button.disabled) {
        if (button.type == "icon") {
          btnArr.push(<Link key={key} title={button.text} onClick={() => {
            if (button.href) navigate(button.href)
            else if (button.click) button.click()
          }}>{button.icon && <button.icon className="icon" />}</Link>)
        } else {
          let icon = <></>
          if (button.icon) icon = null //icon = iconMap[button.icon]
          if (button.type == "secondary") {
            btnArr.push(<Button key={key} variant="contained" disabled={button.disabled} color="secondary" onClick={() => {
              if (button.href) navigate(button.href)
              else if (button.click) button.click()
            }}>{icon}{button.text}</Button>)
          } else if (button.type == "tertiary") {
            btnArr.push(<Button key={key} variant="outlined" disabled={button.disabled} onClick={() => {
              if (button.href) navigate(button.href)
              else if (button.click) button.click()
            }}>{icon}{button.text}</Button>)
          } else {
            btnArr.push(<Button key={key} variant="contained" disabled={button.disabled} onClick={() => {
              if (button.href) navigate(button.href)
              else if (button.click) button.click()
            }}>{icon}{button.text}</Button>)
          }
        }
      }
    });
  }
  return btnArr;
}

export const handleContinueEmpty = ({ dispatch, portalId, includeShot }) => {
  const id = portalId || nanoid(12);
  const shot = includeShot !== undefined ? includeShot : false;
  const story = emptyStory(id, includeShot);
  dispatch({ type: "NEW_ACTIVE_STORY", payload: { newStory: story } });
};

export const addShotUserRef = ({ dispatch, state, shot }) => {
  console.log("ADDING SHOT REF", state.generate)
  // if (state.generate.userRefs?.length == totalRefs) {
  //   toast.error("You have reached the maximum number of references allowed for this output method.");
  //   return;
  // }
  const getLastTake = () => {
    const filteredTakes = state.stories.activeTakeList.filter(take => take.shot_id === shot.id)
    return sortTakes(filteredTakes)[0]
  };

  const take = (state.stories.activeTakeList.find(take => take.id === shot.selected_take_id))
    ? state.stories.activeTakeList.find(take => take.id === shot.selected_take_id)
    : getLastTake();

  addTakeUserRef({ dispatch, state, takes: [take] });
};

export const addImgUserRefs = ({ dispatch, state, refs }) => {
  console.log("ADDING IMG REF", state.generate)
  let takes = []
  if (state.generate.userRefs?.length == 3) {
    toast.error("You have reached the maximum number of references allowed for this output method.");
    return;
  }
  refs.forEach(ref => {
    const path = ref.path;
    console.log("ref user ref", ref);
    let take = state.stories.activeTakeList.find(take => take.thumbnail === path || take.image_path === path || take.stream_path === path) || null;

    if (!take) {
      take = state.stories.activeRefList?.find(take => take.thumbnail === path || take.image_path === path || take.stream_path === path) || null;
    }

    console.log("take", take)

    if (!take) {
      take = {
        id: uuidv4(),
        thumbnail: path,
        image_path: path,
        stream_path: path,
        is_ref: true,
        shot_id: "reference"
      };
      dispatch({ type: "ADD_TAKE_REF", payload: { take: take } });
    }

    if (take) takes.push(take);
  });
  addTakeUserRef({ dispatch, state, takes });
};

export const getAvailableModels = (method, disallowedModels = []) => {
  const models = hostConfig.aiModels;
  const modelsArr = Array.from(models, ([key, data]) => ({ key, data }))
  if (method) return modelsArr.filter(item => item.data.method === method && !disallowedModels.includes(item.key))
  return modelsArr.filter(item => !disallowedModels.includes(item.key))
};

export const addTakeUserRef = ({ dispatch, state, takes }) => {
  if (!state.generate.method) return;
  const userRefs = state.generate?.userRefs || [];
  const active = userRefs?.filter(ref => ref.active).length || 0;
  const defaultModels = state.stories.activeStory?.defaultModels || [];
  console.log("add take ref")
  let updateModel = false;
  let updateMethod = false;
  const getNewRefType = (take) => {
    let ref;
    switch (state.generate.method) {
      case "vid2vid":
        return userRefs?.find(ref => ref.active && ref.type === "vid") ? "ref" : "vid";
      case "im2vid":
        return userRefs?.find(ref => ref.active && ref.type === "first") ? "ref" : "first";
      case "text2vid":
        ref = (userRefs?.find(ref => ref.active && ref.type === "first") || !userRefs.length) ? "first" : "ref";
        if (take && !state.stories.activeVeneerLUT?.[take.id] && !userRefs?.find(ref => ref.active && ref.type === "vid")) {
          ref = "vid";
        }
        if (ref === "vid") {
          updateMethod = "vid2vid";
        } else if (ref === "first") {
          updateMethod = "im2vid";
        }
        return ref;
      default:
        return "ref";
    }
  }
  console.log("ADDING TAKE REF", takes, userRefs, userRefs.length)
  const availableModels = getAvailableModels(updateMethod || state.generate.method, state.generate.disallowedModels);
  const currModel = state.generate.model && availableModels.find(model => model.key === state.generate.model) ? state.generate.model : null;
  const models = hostConfig.aiModels;
  const defaultModel = (defaultModels && defaultModels[updateMethod || state.generate.method]) ? defaultModels[updateMethod || state.generate.method] : methods.get(updateMethod || state.generate.method).defaultModel;
  const model = currModel || defaultModel;
  console.log("model", availableModels, currModel, defaultModel, model)
  console.log("state generate", state.generate)
  const method = methods.get(updateMethod || state.generate.method);
  const modelData = models.get(model);
  const max = modelData.maxRefs || 0;
  const total = max + (method.requiresMedia ? 1 : 0);
  console.log("total refs", method, modelData, max, total, updateMethod)
  let newUserList = [];

  for (const take of takes) {
    if (userRefs.length && userRefs.find(obj => obj.id === take.id)) {
      toast.error("This reference take has already been added.");
      return;
    }

    if (userRefs.length >= total) {
      console.log("handle model limit")
      updateModel = handleModelLimit({ total: total + 1, model, newMethod: updateMethod, state });
      console.log("modelLimit", updateModel)
      if (!updateModel) {
        return;
      }
    }
    const newRefType = getNewRefType(take);
    if (!state.stories?.activeRefList.find(ref => ref.id === take.id)) {
      console.log("Adding take ref to story refs", take)
      dispatch({ type: "UPDATE_TAKE", payload: { ...take, is_ref: true } });
    }
    newUserList.push({ id: take.id, active: (active < total || updateModel) ? true : false, type: newRefType });
  }
  newUserList = [...userRefs, ...newUserList];
  console.log("newUserList", newUserList)
  const payload = { userRefs: newUserList }
  if (updateModel) payload.model = updateModel;
  console.log("payload", payload)
  dispatch({ type: "UPDATE_USER_STATE", payload: payload });
  if (!updateModel) toast.success("Adding reference...");
}

export const handleModelLimit = (props) => {
  const { total, model, newMethod, state } = props;
  let newModel = false;
  const models = hostConfig.aiModels;
  const method = newMethod || state.generate.method;
  // const defaultModels = state.stories.activeStory?.defaultModels || [];
  // const defaultModel = (defaultModels && defaultModels[state.generate.method]) ? defaultModels[state.generate.method] : methods.get(state.generate.method).defaultModel;
  const disallowedModels = state.generate.disallowedModels || [];
  const availableModels = getAvailableModels(method, disallowedModels);
  // const currModel = state.generate.model && availableModels.find(model => model.key === state.generate.model) || null;
  // const model = currModel || defaultModel;
  // const modelData = models.get(currModel);
  const modelData = models.get(model);
  console.log("model limit", model, total, method, methods.get(method).requiresMedia, modelData);
  // const max = modelData.maxRefs;
  //const max = methods.get(method).requiresMedia ? total - 1 : total;
  const filtered = availableModels.filter(item => item.data.method === method && item.data.maxRefs >= modelData.maxRefs && item.data.maxRefs >= total);
  console.log("filtered1", filtered, availableModels)
  if (filtered.length == 0) {
    if (state.generate.method == "vid2vid" || state.generate.method == "im2vid") toast.error(`Maximum number of refs reached. If you want to add more refs, change the ref types to "reference"`);
    else toast.error(`Maximum number of refs reached for this output method`);
    return false
  }
  const family = filtered.find(item => item.data.family == modelData.family)
  if (family) {
    console.log("family", family)
    newModel = family.key
  } else {
    console.log("no family", filtered[0])
    newModel = filtered[0].key;
  }
  console.log(newModel);
  if (newModel) toast.success("Switching to model " + models.get(newModel).name + " to accommodate additional references.");
  return newModel;
}

export const getRefImages = async (veneer) => {
  if (!veneer) return [];
  let refs = [];
  if (veneer.ref_images && veneer.ref_images.length > 0) {
    for (let ref_image of veneer.ref_images) {
      if (!ref_image) return;
      const url = await getMediaUrl(ref_image);
      if (url) refs.push({ path: ref_image, url: url });
    }
  }
  if (veneer.video_path && veneer.video_path.indexOf(baseVideos["prod"]) === -1 && veneer.video_path.indexOf(baseVideos["dev"]) === -1) {
    const url = await getMediaUrl(veneer.video_path);
    if (url) refs.push({ path: veneer.video_path, url: url });
  }
  return refs;
}